import { Outlet } from "react-router-dom";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import { PaymentProvider } from "../context/PaymentTokContext";

function Layout() {

    return (
        <>
            <Header />
            <PaymentProvider>
                <main style={{ minHeight: "calc(100vh - 385px)" }}>
                    <Outlet />
                </main>
            </PaymentProvider>
            <Footer />
        </>
    );
}

export default Layout;